import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.471 6.471a4.529 4.529 0 1 1 8.504 2.172L10.848 6.47 8.08 9.63 5.312 6.471 4.085 8.75a4.508 4.508 0 0 1-.615-2.28Zm.105 3.22a5.471 5.471 0 1 1 8.903-.078L15 14.473h-4.152l-1.384-2.316-1.384 2.316-1.384-2.316-1.544 2.316H1l2.576-4.78Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { MetroNn16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var MetroNn16 = createIcon(IconComponent);